import { useCallback, useEffect, useState } from "react"

/** `copied` stays true for `ms` after the latest `markCopied()`; the reset is cleared on unmount. */
export function useCopiedFlag(ms: number) {
	const [copies, setCopies] = useState(0)

	useEffect(() => {
		if (copies === 0) return
		const timer = setTimeout(() => setCopies(0), ms)
		return () => clearTimeout(timer)
	}, [copies, ms])

	const markCopied = useCallback(() => setCopies((count) => count + 1), [])
	return [copies > 0, markCopied] as const
}
